import { PremiumFeatureConfig, PremiumFeatureKey, PremiumSlide } from "types/premium.types"
import { CLOSE_FRIENDS, CREATE_ITEM, CREATE_LIST } from "constants/index"

export const PREMIUM_SLIDES: PremiumSlide[] = [
  {
    key: "main",
    imageName: "",
    theme: "light"
  },
  {
    key: CLOSE_FRIENDS,
    imageName: "close-friend",
    theme: "dark"
  },
  {
    key: CREATE_ITEM,
    imageName: "item",
    theme: "light"
  },
  {
    key: CREATE_LIST,
    imageName: "list",
    theme: "dark"
  }
]

export const PREMIUM_FEATURES: Record<PremiumFeatureKey, PremiumFeatureConfig> = {
  [CLOSE_FRIENDS]: { premiumOnly: true },
  [CREATE_LIST]: { premiumOnly: false, active: false },
  [CREATE_ITEM]: { premiumOnly: false, active: false }
}

export const PREMIUM_FALLBACK_MODE = {
  ONBOARD: "ONBOARD",
  SILENT: "SILENT",
  REDIRECT: "REDIRECT"
}
